

























































import { config } from "@/config";
import { Component, Vue } from "vue-property-decorator";
import { app } from "@/models/Application";

@Component({})
export default class extends Vue {
  public dialog = false;
  public drawer = null;

  public items = [
    { icon: "home", text: "Home", name: "admin_home" },
    { icon: "fastfood", text: "Products / Menu", name: "products" },
    { icon: "grade", text: "Manage Promotions", name: "promotions" },
    { icon: "settings", text: "Floor Layout", name: "floorlayouts" },
    { icon: "table_chart", text: "Manage Tables", name: "tables" },
    { icon: "people", text: "Manage Staff", name: "admin_staff" },
    { icon: "restaurant", text: "Manage Orders", name: "orders" },
    { icon: "layers", text: "Table Assigments", name: "table_assigments" },
    {
      icon: "restaurant",
      text: "Restaurant Profile",
      name: "restaurant_profile"
    },
    {
      icon: "show_chart",
      text: "Reports",
      subLinks: [
        {
          text: "Sales Per Product Report",
          name: "sales-per-product-report"
        },
        {
          text: "Sales Per Day Report",
          name: "sales-per-day-report"
        }
      ]
    }
  ];
}
